<template>
	<v-container fluid>
		<QuestionnaireEmailModal :show="questionnaireEmailModal.show" :contact="questionnaireEmailModal.contact"
								 :opportunities="questionnaireEmailModal.opportunities"
								 @callback="questionnaireEmailModalCallback"/>
		<v-dialog v-model="questionnairePopupShow" :persistent="false" max-width="715">
			<v-card>
				<v-card-text>
					<v-layout row wrap pt-3 pl-1>
						<v-flex md5 xs12>
							<InputField
								v-model="questionnaire.name"
								:label="'* '+$t('fields.name')"
								:readonly="true"></InputField>
						</v-flex>
						<v-flex md5 xs12 offset-md1>
							<InputField
								v-model="questionnaire.realestate_type"
								:label="'* '+$t('fields.realestateType')"
								:readonly="true"
							></InputField>
						</v-flex>
						<v-flex md5 xs12>
							<InputField
								v-model="questionnaire.rooms_no"
								:label="'* '+$t('fields.roomsNo')"
								:readonly="true"></InputField>
						</v-flex>
						<v-flex md5 xs12>
						</v-flex>
						<v-flex md5 xs12>
							<CurrencyField
								v-model="questionnaire.price_from"
								:suffix="'EUR'"
								:label="'* '+$t('fields.priceFrom')"
								:readonly="true"></CurrencyField>
						</v-flex>
						<v-flex md5 xs12 offset-md1>
							<CurrencyField
								v-model="questionnaire.price_to"
								:suffix="'EUR'"
								:label="'* '+$t('fields.priceTo')"
								:readonly="true"></CurrencyField>
						</v-flex>
						<v-flex md5 xs12>
							<CurrencyField
								v-model="questionnaire.area_from"
								:suffix="''"
								:label="'* '+$t('fields.areaFrom')"
								:readonly="true"></CurrencyField>
						</v-flex>
						<v-flex md5 xs12 offset-md1>
							<CurrencyField
								v-model="questionnaire.area_to"
								:suffix="''"
								:label="'* '+$t('fields.areaTo')"
								:readonly="true"></CurrencyField>
						</v-flex>
						<br>
						<v-flex md5 xs12>
								<div>
								<DropdownMultiple
									v-model="questionnaire.neighbourhoods"
									:ajax="true"
									:data="'neighbourhoods'"
									:label="$t('fields.neighbourhood')"
									:readonly="true"></DropdownMultiple>
								</div>
							</v-flex>
						<v-flex xs12>
							<div>
								<span
									style="display:inline-block; padding-top:10px; color:grey;">{{ $t('labels.location') }}</span>
								<v-radio-group v-model="questionnaire.sea_selection" row class="ma-0 pt-1" hide-details
											   :readonly="true">
									<v-radio :label="$t('fields.sea1st')" :value="1"></v-radio>
									<v-radio :label="$t('fields.sea2nd')" :value="2"></v-radio>
									<v-radio :label="$t('fields.seaBoth')" :value="3"></v-radio>
									<v-radio :label="$t('fields.seaNone')" :value="4"></v-radio>
								</v-radio-group>
							</div>
						</v-flex>
						<span
							style="display:inline-block; padding-top:10px; color:grey;">{{ $t('labels.additional_info') }}</span>
						<v-flex xs12>
							<CheckBox
								:label="$t('fields.seaView')"
								v-model="questionnaire.sea_view"
								:simple="true"
								:readonly="true"></CheckBox>
						</v-flex>
						<v-flex xs12>
							<CheckBox
								:label="$t('fields.elevator')"
								v-model="questionnaire.elevator"
								:simple="true"
								:readonly="true"></CheckBox>
						</v-flex>
						<v-flex xs12>
							<CheckBox
								:label="$t('fields.garden')"
								v-model="questionnaire.garden"
								:simple="true"
								:readonly="true"></CheckBox>
						</v-flex>
						<v-flex xs12>
							<CheckBox
								:label="$t('fields.pool')"
								v-model="questionnaire.pool"
								:simple="true"
								:readonly="true"></CheckBox>
						</v-flex>
						<br>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-layout row wrap>
			<v-flex xs12 v-if="databaseUpdateNeeded === true">
				<v-card style="border-left:5px solid red; text-align:center; line-height:10px; background-color:#f8cfcf;">
				<span
					style="display:inline-block; color:grey; font-size:12px; margin-top:8px;"><b>{{ $t('labels.databaseOutdated') }}</b></span><br><br>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<span
					style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{ $t('labels.reportsOpportunityQuestionnaire') }}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md3 xs12 offset-md1>
				<Dropdown
					v-if="showContactDropdown === true"
					v-model="contact"
					:ajax="true"
					:data="'buyers'"
					:loader="true"
					:label="'* '+$t('fields.firstAndLastName')"
					@optionsLoaded="buyerOptionsLoaded"></Dropdown>
				<Dropdown
					v-if="showQuestionnaire === true"
					v-model="questionnaireDropdownId"
					:ajax="true"
					:data="'questionnaires/'+contact.id"
					:label="'* '+$t('fields.questionnaire')"></Dropdown>
				<InputField
					v-model="contact.email"
					:label="$t('fields.email')"
					:readonly="true"></InputField>
				<InputField
					v-model="contact.phone_no"
					:label="$t('fields.telephoneNo')"
					:readonly="true"></InputField>
				<v-btn v-if="questionnaireDropdownId != null" color="grey lighten-1" @click="checkQuestionnaire" class="my-4">
					{{ $t('buttons.checkQuestionnaire') }}
				</v-btn>
			</v-flex>
			<v-flex md3 xs12 offset-md1>
				<InputField
					v-model="contact.neighbourhood"
					:label="$t('fields.neighbourhood')"
					:readonly="true"></InputField>
				<InputField
					v-model="contact.city"
					:label="$t('fields.city')"
					:readonly="true"></InputField>
				<InputField
					v-model="contact.zipcode"
					:label="$t('fields.zipCode')"
					:readonly="true"></InputField>
				<InputField
					v-model="contact.country"
					:label="$t('fields.country')"
					:readonly="true"></InputField>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-4>
			<v-flex xs1 v-if="opportunitiesTable.items.length != 0" pl-1>
				<v-tooltip bottom>
					<v-btn @click="selectAll" icon slot="activator">
						<span v-if="this.selectedAll != true"><v-icon small>fa-check-square</v-icon></span>
						<span v-if="this.selectedAll == true"><v-icon small>far fa-square</v-icon></span>
					</v-btn>
					<span>{{ $t('labels.selectAll') }}</span>
				</v-tooltip>
			</v-flex>
			<v-flex xs1 v-if="opportunitiesTable.items.length != 0">
				<v-btn @click="sendEmails" color="grey lighten-1">
					<v-icon small>fa-envelope</v-icon>&nbsp;&nbsp;{{ $t('buttons.reportSendEmails') }}
				</v-btn>
			</v-flex>
			<v-flex xs10 v-if="opportunitiesTable.items.length != 0" text-xs-right>
				<v-tooltip bottom>
					<v-btn @click="excelExport" icon slot="activator">
						<v-icon small>fa-file-excel</v-icon>
					</v-btn>
					<span>{{ $t('tooltips.excel') }}</span>
				</v-tooltip>
			</v-flex>
			<v-flex xs12 v-if="opportunitiesTable.items.length == 0" text-xs-right>
				<v-tooltip bottom>
					<v-btn @click="excelExport" icon slot="activator">
						<v-icon small>fa-file-excel</v-icon>
					</v-btn>
					<span>{{ $t('tooltips.excel') }}</span>
				</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<DataTableContacts
					:excel="false"
					:filter="false"
					:headers="opportunitiesTable.headers"
					:items="opportunitiesTable.items"
					:total="opportunitiesTable.total"
					@reload="reloadData"
					@excel="excelExport"
				>
					<template #row="props">
						<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.index)">
							<td width="100px" style="text-align:center">
								<CheckBox v-model="props.item.selected" :simple="true"></CheckBox>
							</td>
							<td width="100px" style="text-align:center">
								<v-tooltip bottom v-if="props.item.brochure_sent">
									<v-btn slot="activator" icon>
										<v-icon small v-if="props.item.brochure_sent">fa-envelope</v-icon>
									</v-btn>
									<span>{{ $t('labels.reportBrochuresSent') }}</span>
								</v-tooltip>
							</td>
							<td width="100px" style="text-align:center" @click="opportunityClick(props.item)">
								{{ props.item.vtiger_id }}
							</td>
							<td width="180px" style="text-align:left" @click="editClick(props.item)">
								{{ props.item.neighbourhood }}
							</td>
							<td width="180px" style="text-align:left" @click="editClick(props.item)">
								{{ props.item.sales_stage }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.rooms_no_display }}
							</td>
							<td width="150px" style="text-align:center" @click="editClick(props.item)">
								<span>{{ props.item.price.toLocaleString() }}</span>
								<span v-if="props.item.price != 0">&nbsp;EUR</span>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.area_display }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.penthouse">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.first_row">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.second_row">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.seaview }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								{{ props.item.floor }}
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.elevator_display">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.garden_display">fa-check</v-icon>
							</td>
							<td width="100px" style="text-align:center" @click="editClick(props.item)">
								<v-icon small v-if="props.item.pool_display">fa-check</v-icon>
							</td>
						</tr>
					</template>
				</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Dropdown from "./trinkets/Dropdown";
import CheckBox from "./trinkets/CheckBox";
import InputField from "./trinkets/InputField";
import QuantityField from './trinkets/QuantityField';
import CurrencyField from './trinkets/CurrencyField.vue';
import DropdownMultiple from "./trinkets/DropdownMultiple";
import DataTableContacts from "./trinkets/DataTableContacts";
import QuestionnaireEmailModal from "./QuestionnaireEmailModal";

export default {
	name: "ReportsRealestate",
	components: {
		QuestionnaireEmailModal,
		DataTableContacts, InputField, Dropdown, CurrencyField, QuantityField, CheckBox, DropdownMultiple
	},
	data: function () {
		return {
			opportunitiesTable: {
				headers: [
					{text: '', value: 'selected', type: '', sortable: false, searchable: false},
					{text: '', value: 'brochure_sent', type: '', sortable: false, searchable: false},
					{text: this.$t('labels.opportunityId'), value: 'vtiger_id', type: 'string', searchable: false},
					{text: this.$t('fields.neighbourhood'), value: 'neighbourhood', type: 'string', searchable: false},
					{text: this.$t('labels.salesStage'), value: 'sales_stage', type: 'string', searchable: false},
					{text: this.$t('labels.rooms_no'), value: 'rooms_no_display', type: 'string', searchable: false},
					{text: this.$t('labels.price'), value: 'price', type: 'string', searchable: false},
					{text: this.$t('labels.areaReport'), value: 'area_display', type: 'string', searchable: false},
					{text: this.$t('labels.penthouse'), value: 'penthouse', type: 'string', searchable: false},
					{text: this.$t('labels.first_row'), value: 'first_row', type: 'string', searchable: false},
					{text: this.$t('labels.second_row'), value: 'second_row', type: 'string', searchable: false},
					{text: this.$t('labels.seaview'), value: 'seaview', type: 'string', searchable: false},
					{text: this.$t('labels.floor'), value: 'floor', type: 'string', searchable: false},
					{text: this.$t('labels.elevator'), value: 'elevator_display', type: 'string', searchable: false},
					{text: this.$t('labels.garden'), value: 'garden_display', type: 'string', searchable: false},
					{text: this.$t('labels.pool'), value: 'pool_display', type: 'string', searchable: false},
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			contact: {
				id: '',
				email: '',
				telephoneNo: '',
				neighbourhood: '',
				city: '',
				zipCode: '',
				neighbourhood: '',
				country: '',
			},
			questionnaire: {
				id: '',
				name: '',
				realestate_type: '',
				rooms_no: '',
				price_from: '',
				price_to: '',
				area_from: '',
				area_to: '',
				sea_1st: '',
				sea_2nd: '',
				sea_view: '',
				elevator: '',
				garden: '',
				pool: '',
				contact_id: '',
				sea_selection: 4,
				neighbourhoods: []
			},
			showContactDropdown: true,
			questionnaireDropdownId: null,
			questionnairePopupShow: false,
			selectedAll: true,
			selectedOpportunities: [],
			showQuestionnaire: false,
			routedFromContacts: false,
			questionnaireEmailModal: {
				show: false,
				contact: null,
				opportunities: null
			},
			contactQuestionnaires: [],
			latestUpdateTime: null,
			databaseUpdateNeeded: false,
		}
	},
	watch: {
		contact: {
			handler: function () {
			},
			deep: true
		},
		"contact.id": {
			handler: function () {
				if (this.routedFromContacts != true) {
					this.opportunitiesTable.items = [];
					this.opportunitiesTable.total = 0;
					this.showQuestionnaire = false;
					this.questionnaireDropdownId = null;
					this.$nextTick(() => {
						this.showQuestionnaire = true;
						this.questionnaire = {
							id: '',
							name: '',
							realestate_type: '',
							rooms_no: '',
							price_from: '',
							price_to: '',
							area_from: '',
							area_to: '',
							sea_1st: '',
							sea_2nd: '',
							sea_view: '',
							elevator: '',
							garden: '',
							pool: '',
							contact_id: '',
							sea_selection: 4,
						}
						this.reloadData();
					});
				}
			},
			deep: true
		},
		questionnaireDropdownId: {
			handler: function () {
				if (this.routedFromContacts != true) {
					this.reloadData();
				}
			},
			deep: true
		},
	},
	methods: {
		buyerOptionsLoaded(){
			this.$nextTick(() => {
				this.routedFromContacts = false;
				this.showQuestionnaire = true;
			});
		},
		questionnaireEmailModalCallback() {
			this.questionnaireEmailModal.show = false;
			this.questionnaireEmailModal.contact = null;
			this.questionnaireEmailModal.opportunities = null;
			this.$notify(vm.$t('alerts.reportEmailsSent'));
			let vm = this;
			this.$nextTick(() => {
				vm.reloadData();
				vm.selectedAll = true;
				vm.selectedOpportunities = [];
			});
		},
		sendEmails() {
			this.selectedOpportunities = [];
			for (const element of this.opportunitiesTable.items) {
				if (element.selected == true) {
					this.selectedOpportunities.push(element);
				}
			}
			if (this.selectedOpportunities.length == 0) {
				this.$alert(this.$t('alerts.noOpportunitiesSelected'));
			} else {
				this.$verify(this.$t('alerts.sendBrochuresConfirmation'), (result) => {
					if (result) {
						this.questionnaireEmailModal.opportunities = this.selectedOpportunities;
						this.questionnaireEmailModal.contact = this.contact;
						this.questionnaireEmailModal.show = true;
					}
				});
			}
		},
		editClick(item) {
			item.selected = !item.selected;
		},
		selectAll() {
			for (const element of this.opportunitiesTable.items) {
				element.selected = this.selectedAll;
			}
			this.selectedAll = !this.selectedAll;
		},
		reloadData() {
			let vm = this;
			if (this.questionnaireDropdownId != null && this.questionnaireDropdownId != '' && this.questionnaireDropdownId != undefined && this.contact != null && this.contact != undefined) {
				let data = {
					questionnaire: this.questionnaireDropdownId,
					contact: this.contact
				}
				this.$APICall('get', 'report-opportunity-questionnaire', data, (data, success) => {
					if (success) {
						vm.opportunitiesTable.items = data.items;
						console.log(typeof(vm.opportunitiesTable.items[0].price));
						vm.opportunitiesTable.total = data.total;
						if (vm.questionnaire.sea_1st == true && vm.questionnaire.sea_2nd == false) {
							vm.questionnaire.sea_selection = 1;
						} else if (vm.questionnaire.sea_1st == false && vm.questionnaire.sea_2nd == true) {
							vm.questionnaire.sea_selection = 2;
						} else if (vm.questionnaire.sea_1st == true && vm.questionnaire.sea_2nd == true) {
							vm.questionnaire.sea_selection = 3;
						} else {
							vm.questionnaire.sea_selection = 4;
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		excelExport() {
			if (this.opportunitiesTable.items != undefined && this.opportunitiesTable.items != null) {
				if (this.opportunitiesTable.items.length != 0) {
					this.$APICall('post', 'excel/report-opportunity-questionnaire', this.opportunitiesTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		checkQuestionnaire() {
			if (this.questionnaireDropdownId != null && this.questionnaireDropdownId != '') {
				this.questionnairePopupShow = true;
				let vm = this;
				this.$APICall('get', 'questionnaires/' + this.questionnaireDropdownId, {}, (data, success) => {
					if (success) {
						vm.questionnaire = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		opportunityClick(item) {
			let routeData = this.$router.resolve('/opportunities/' + item.vtiger_id);
			window.open(routeData.href, '_blank');
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		if (this.$route.params.contact_id != null && this.$route.params.questionnaire_id != null) {
			this.questionnaireDropdownId = parseInt(this.$route.params.questionnaire_id);
			this.routedFromContacts = true;
			this.showContactDropdown = false;
			let vm = this;
			this.$APICall('get', 'contacts/' + this.$route.params.contact_id, null, (data, success) => {
				if (success) {
					let usableData1 = JSON.parse(JSON.stringify(data['contact']));
					vm.contact = usableData1;
					vm.$nextTick(() => {
						vm.showContactDropdown = true,
						vm.reloadData();
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
		let vm = this;
		this.$APICall('get', 'latest-update-time-reports', {}, (data, success) => {
			if (success) {
				let now = new Date();
				if(data != null && data != undefined && Object.keys(data).length !== 0){
					vm.latestUpdateTime = new Date(data);
					vm.latestUpdateTime = new Date(vm.latestUpdateTime.getTime() + 30*60000);
					if(now > vm.latestUpdateTime){
						vm.databaseUpdateNeeded = true;
					}
				}
				else{
					vm.databaseUpdateNeeded = true;
				}
			}
			else{
				vm.databaseUpdateNeeded = true;
			}
		});
	}
}
</script>

<style scoped>

</style>
